import { render } from "./KnowledgeInfo.vue?vue&type=template&id=2f00fcd2&scoped=true"
import script from "./KnowledgeInfo.vue?vue&type=script&lang=js"
export * from "./KnowledgeInfo.vue?vue&type=script&lang=js"

import "./KnowledgeInfo.vue?vue&type=style&index=0&id=2f00fcd2&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f00fcd2"]])

export default __exports__